// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__L7ntr","modal":"Modal_modal__ZDVCz","title":"Modal_title__aBdt2","button":"Modal_button__BZjd1"};